import * as React from 'react';
import PropTypes from "prop-types";
import DateFnsUtils from '@date-io/date-fns';
import {format} from "date-fns";
import {isEmpty} from "lodash";
import {DatePicker, DateTimePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import {FormFeedback, Input, InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import Tooltip from "../components/Tooltip";
import uuid from "react-native-uuid";
import moment from "moment";
import {getLocaleDateFns} from "../i18n/init";
import {useTranslation} from "react-i18next";

function AppDatePicker(outerProps) {
  const { t } = useTranslation('app_date_picker')
  const [idTooltip, setIdTooltip] = React.useState('x' + uuid.v4());
  const [autoFocus, setAutoFocus] = React.useState(outerProps.autoFocus);
  const [value, setValue] = React.useState(null);
  const inputRef = React.createRef();
  const DateComponent = outerProps.dateTime ? DateTimePicker : DatePicker;

  React.useEffect(() => setValue(outerProps.value), [outerProps.value]);

  const handlerOnChange = (value) => {
    setValue(value);
    outerProps.onChange(value ? format(value, getFormat()) : null);
  }

  const getFormat = () => {
    if (outerProps.monthSelect) {
      return 'yyyy-MM';
    }
    return outerProps.dateTime ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
  }

  const renderInput = (innerProps) => {
    setTimeout(() => {
      if (innerProps.autoFocus && innerProps.inputProps.inputRef?.current) {
        innerProps.inputProps.inputRef.current.click();
      }
    }, 1);

    return (
      <InputGroup className="d-flex">
        <Input
          disabled={innerProps.disabled}
          invalid={!isEmpty(innerProps?.errors)}
          innerRef={innerProps.inputProps.inputRef}
          className={`flex-grow-1 ${innerProps.inputProps.className}`}
          placeholder={innerProps.inputProps.placeholder}
          type="text"
          onClick={innerProps.onClick}
          value={value ? innerProps.value : null}
          onChange={innerProps.inputProps.onChange}
          onBlur={innerProps.inputProps.onBlur}
        />

        {outerProps.isClearable && (
          <>
            <InputGroupAddon
              id={idTooltip}
              addonType="append"
              className="cursor-pointer"
              onClick={() => innerProps.inputProps.onChange(null)}
            >
              <InputGroupText><i className="fas fa-times" /></InputGroupText>
            </InputGroupAddon>
            <Tooltip className="tooltip-on-modal" id={idTooltip} msg={'Wyczyść date'} />
          </>
        )}

        {outerProps.inputGroupAddonAppend && (
          <InputGroupAddon addonType="append">
            {outerProps.inputGroupAddonAppend}
          </InputGroupAddon>
        )}

        {!isEmpty(innerProps?.errors) && (
          <FormFeedback className="d-block">{innerProps.errors}</FormFeedback>
        )}
      </InputGroup>
    )
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={getLocaleDateFns()}>
      <DateComponent
        TextFieldComponent={outerProps?.renderInput ?? renderInput}
        views={outerProps.monthSelect ? ["year", "month"] : undefined}
        openTo={outerProps.openTo || (outerProps.monthSelect ? 'month' : undefined)}
        inputProps={{
          className: outerProps.inputClass,
          placeholder:
            outerProps.placeholder !== false && outerProps.placeholder !== true && outerProps.placeholder
              ? outerProps.placeholder
              : outerProps.placeholder === true && getFormat().toUpperCase(),
          inputRef,
          onChange: handlerOnChange,
          onBlur: () => outerProps.onBlur && outerProps.onBlur(),
        }}
        autoOk
        margin="normal"
        id="date-picker"
        ampm={false}
        format={getFormat()}
        class="my-0"
        value={value ?? moment().format('YYYY-MM-DD 00:00')}
        isClearable={outerProps.isClearable}
        autoFocus={autoFocus}
        onClose={() => setAutoFocus(false)}
        onChange={handlerOnChange}
        minDate={outerProps.minDate}
        maxDate={outerProps.maxDate}
        errors={outerProps.errors}
        invalidDateMessage={t('invalid_date_message')}
        cancelLabel={t('cancel_label')}
        okLabel={t('ok_label')}
        disabled={outerProps.disabled}
      />
    </MuiPickersUtilsProvider>
  );
}

AppDatePicker.defaultProps = {
  disabled: false,
  inputClass: '',
  value: null,
  dateTime: false,
  isClearable: false,
  autoFocus: false,
  placeholder: true,
  minDate: undefined,
  maxDate: undefined,
  monthSelect: false,
};

AppDatePicker.propTypes = {
  openTo: PropTypes.string,
  renderInput: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.oneOfType([PropTypes.bool, PropTypes.string,]),
  inputClass: PropTypes.string,
  isClearable: PropTypes.bool,
  autoFocus: PropTypes.bool,
  dateTime: PropTypes.bool,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
  errors: PropTypes.object,
  monthSelect: PropTypes.bool,
};

export default AppDatePicker;
